import request from "arcdynamic-request";
import {backendServicesUrl} from '../consts/env';

/**
 * Executes a query against the local backend's Arc shim.
 * This is used for gradual migration of pages from the real Arc API to the local database.
 */
export function executeBackendQuery({queryName, params = false, options = false, expireTime = false}) {
    const req = options ?
        {
            service: 'arcimedes',
            action: 'open.dataquery.execute',
            params: [queryName],
            options: options
        }
        :
        {
            service: 'arcimedes',
            action: 'open.dataquery.execute',
            params: [queryName, {param: params}]
        };

    if (expireTime) {
        return request(backendServicesUrl, req, {expires: expireTime});
    }
    return request(backendServicesUrl, req);
}
